import { leadGenAdLicenseWidth } from "./lead-gen-ad-measure";

/** Conservative Outfit advances include render slack. Never clip or rewrite a claim. */
export function fitReelText(
  text: string,
  width: number,
  maxLines: number,
  maxSize: number,
  minSize: number,
) {
  const words = text.trim().split(/\s+/);
  for (let size = maxSize; size >= minSize; size--) {
    const lines: string[] = [];
    let line = "";
    let tooWide = false;
    for (const word of words) {
      if (leadGenAdLicenseWidth(word, size) > width) {
        tooWide = true;
        break;
      }
      const next = line ? `${line} ${word}` : word;
      if (leadGenAdLicenseWidth(next, size) > width) {
        lines.push(line);
        line = word;
      } else line = next;
    }
    if (line) lines.push(line);
    if (tooWide || lines.length > maxLines) continue;
    if (maxLines === 2 && words.length > 1 && text.length >= 16) {
      const options = words
        .slice(1)
        .map((_, index) => [
          words.slice(0, index + 1).join(" "),
          words.slice(index + 1).join(" "),
        ]);
      const balanced = options
        .filter((pair) =>
          pair.every((value) => leadGenAdLicenseWidth(value, size) <= width),
        )
        .sort(
          (a, b) =>
            Math.abs(
              leadGenAdLicenseWidth(a[0] ?? "", size) -
                leadGenAdLicenseWidth(a[1] ?? "", size),
            ) -
            Math.abs(
              leadGenAdLicenseWidth(b[0] ?? "", size) -
                leadGenAdLicenseWidth(b[1] ?? "", size),
            ),
        )[0];
      if (balanced) return { lines: balanced, size };
    }
    return { lines, size };
  }
  throw new Error(
    `Reel copy needs rewriting to fit ${maxLines} lines at ${minSize}px: ${text}`,
  );
}

export const REEL_TEXT_SLOTS = {
  hook: { width: 848, maxLines: 2, maxSize: 88, minSize: 72 },
  bridge: { width: 848, maxLines: 2, maxSize: 88, minSize: 72 },
  message: { width: 682, maxLines: 3, maxSize: 48, minSize: 44 },
  cta: { width: 682, maxLines: 1, maxSize: 38, minSize: 32 },
} as const;
export function fitReelStoryText(
  story: Record<keyof typeof REEL_TEXT_SLOTS, string>,
) {
  const fitSlot = (key: keyof typeof REEL_TEXT_SLOTS) => {
    const slot = REEL_TEXT_SLOTS[key];
    return fitReelText(
      story[key],
      slot.width,
      slot.maxLines,
      slot.maxSize,
      slot.minSize,
    );
  };
  return {
    hook: fitSlot("hook"),
    bridge: fitSlot("bridge"),
    message: fitSlot("message"),
    cta: fitSlot("cta"),
  };
}
